module.exports = __webpack_public_path__ + "img/SH2D_30001.92e98e56.png";